// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddPurchaseOrderMutation($input: AddPurchaseOrderInput!) {
    addPurchaseOrder(input: $input) {
      purchaseOrderEdge {
        node {
          id
          poNumber
          vendor {
            id
            vendorNumber
            name
          }
          status
          totalAmount
          expectedDeliveryDate
          notes
          requestedBy {
            id
            firstName
            lastName
          }
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_ADD',
          parentID: ROOT_ID,
          connectionInfo: [
            {
              key: 'PurchaseOrderList_purchaseOrders',
              rangeBehavior: 'prepend',
            },
          ],
          edgeName: 'purchaseOrderEdge',
        },
      ],
    });
  },
};
